(function () {
  if (typeof window === 'undefined') return;
  if (typeof document === 'undefined') return;

  var initialized = false;

  function init() {
    if (initialized) return;

    var container = document.querySelector('[data-back-to-top]');
    if (!container) return;

    var button = container.querySelector('button');
    if (!button) return;

    initialized = true;

    var DEBUG = window.__BACKTOTOP_DEBUG__ === true;
    if (DEBUG) console.log('[back-to-top] Initialized');

    var prefersReduced = false;
    try {
      prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (err) {
      prefersReduced = false;
    }

    var threshold = 1000;
    var isVisible = false;
    var ticking = false;

    container.setAttribute('aria-hidden', 'true');

    function adjustForOneTrust() {
      var banner = document.getElementById('onetrust-banner-sdk');
      var messenger = document.getElementById('qualified-messenger-frame');
      var totalOffset = 0;

      if (DEBUG) {
        console.log('[back-to-top] adjustForOneTrust called', {
          banner: banner ? 'found' : 'not found',
          bannerHeight: banner ? banner.offsetHeight : 0,
          messenger: messenger ? 'found' : 'not found',
          messengerHeight: messenger ? messenger.offsetHeight : 0
        });
      }

      if (banner && banner.offsetHeight > 0) {
        totalOffset += banner.offsetHeight + parseFloat(getComputedStyle(document.documentElement).fontSize);
        if (DEBUG) console.log('[back-to-top] OneTrust banner detected, offset:', totalOffset);
      }

      if (messenger && messenger.offsetHeight > 0) {
        totalOffset += messenger.offsetHeight + 16;
        if (DEBUG) console.log('[back-to-top] Qualified messenger detected, total offset:', totalOffset);
      }

      if (totalOffset > 0) {
        var bottomValue = 'calc(' + totalOffset + 'px + 2rem + env(safe-area-inset-bottom, 0px))';
        container.style.bottom = bottomValue;
        if (DEBUG) console.log('[back-to-top] Setting bottom to:', bottomValue);
      } else {
        container.style.bottom = '';
        if (DEBUG) console.log('[back-to-top] Resetting bottom (no widgets found)');
      }
    }

    function show() {
      if (isVisible) return;
      isVisible = true;
      container.classList.add('is-visible');
      container.setAttribute('aria-hidden', 'false');
      adjustForOneTrust();
    }

    function hide() {
      if (!isVisible) return;
      isVisible = false;
      container.classList.remove('is-visible');
      container.setAttribute('aria-hidden', 'true');
    }

    function update() {
      var current = window.pageYOffset || document.documentElement.scrollTop || 0;
      var farEnough = current >= threshold;

      if (!farEnough) {
        hide();
      } else {
        show();
      }

      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });

    button.addEventListener('click', function (event) {
      event.preventDefault();
      hide();
      window.scrollTo({
        top: 0,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
    });

    var adjustRaf = null;
    function throttledAdjust() {
      if (adjustRaf) return;
      adjustRaf = requestAnimationFrame(function() {
        adjustForOneTrust();
        if (observingBanner) {
          startStabilityTimer();
        }
        adjustRaf = null;
      });
    }

    var observer = new MutationObserver(throttledAdjust);
    var banner = document.getElementById('onetrust-banner-sdk');
    var checkBanner = null;
    var stabilityTimer = null;
    var maxWaitTimer = null;
    var observingBanner = false;

    function stopStabilityTimer() {
      if (stabilityTimer) {
        clearTimeout(stabilityTimer);
        stabilityTimer = null;
      }
    }

    function stopMaxWaitTimer() {
      if (maxWaitTimer) {
        clearTimeout(maxWaitTimer);
        maxWaitTimer = null;
      }
    }

    function startStabilityTimer() {
      stopStabilityTimer();
      stabilityTimer = setTimeout(function() {
        disconnectObserver();
      }, 2000);
    }

    function disconnectObserver() {
      if (checkBanner) {
        clearInterval(checkBanner);
        checkBanner = null;
      }
      stopStabilityTimer();
      stopMaxWaitTimer();
      try {
        observer.disconnect();
      } catch (_){ }
      observingBanner = false;
    }

    if (banner) {
      observer.observe(banner, {
        attributes: true,
        attributeFilter: ['style', 'class']
      });

      observingBanner = true;
      startStabilityTimer();
    } else {
      observer.observe(document.body, {
        childList: true,
        subtree: false
      });

      stopMaxWaitTimer();
      maxWaitTimer = setTimeout(function() {
        disconnectObserver();
      }, 10000);

      checkBanner = setInterval(function() {
        var foundBanner = document.getElementById('onetrust-banner-sdk');
        var foundMessenger = document.getElementById('qualified-messenger-frame');

        if (foundBanner || foundMessenger) {
          clearInterval(checkBanner);
          checkBanner = null;
          observer.disconnect();

          if (foundBanner) {
            observer.observe(foundBanner, {
              attributes: true,
              attributeFilter: ['style', 'class']
            });
          }

          if (foundMessenger) {
            observer.observe(foundMessenger, {
              attributes: true,
              attributeFilter: ['style', 'class']
            });
          }

          throttledAdjust();
          stopMaxWaitTimer();
          observingBanner = true;
          startStabilityTimer();
        }
      }, 500);
    }

    var messengerCheck = setInterval(function() {
      var messenger = document.getElementById('qualified-messenger-frame');
      if (messenger) {
        clearInterval(messengerCheck);
        throttledAdjust();
      }
    }, 500);

    setTimeout(function() {
      clearInterval(messengerCheck);
    }, 10000);

    var preloaderComplete = false;

    function startAdjustments() {
      preloaderComplete = true;
      adjustForOneTrust();
      setTimeout(adjustForOneTrust, 100);
      setTimeout(adjustForOneTrust, 500);
      setTimeout(adjustForOneTrust, 1000);
    }

    window.addEventListener('preloaderComplete', startAdjustments, { once: true });

    setTimeout(function() {
      if (!preloaderComplete) {
        var preloader = document.getElementById('pagePreloader');
        if (!preloader || preloader.classList.contains('preloader-hidden')) {
          startAdjustments();
        }
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
